import z from 'zod';
import { CampaignType } from '~/enums';

const paymentPlanInstallmentDTOSchema = z.strictObject({
  installment: z.number().int().positive(),
  dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid ISO date format'),
  amortization: z.number().nonnegative(),
  monthlyFee: z.number().nonnegative(),
  totalAmount: z.number().nonnegative(),
  savedAmount: z.number().nonnegative().optional(),
  discountPercentage: z.number().min(0).max(100).optional(),
  originalMonthlyFee: z.number().nonnegative().optional(),
});

const paymentPlanResponseDTOSchema = z.strictObject({
  installments: z.array(paymentPlanInstallmentDTOSchema).min(1),
  campaign: z
    .object({
      type: z.nativeEnum(CampaignType),
      principalFreeMonths: z.number().nullable().optional(),
      interestRateDiscount: z.number().nullable().optional(),
    })
    .nullable()
    .optional(),
});

export const paymentPlanDTOSchemas = {
  getPaymentPlanRes: paymentPlanResponseDTOSchema,
  paymentPlanInstallment: paymentPlanInstallmentDTOSchema,
};
